/**
 * Project: bicc-trafig
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2021-07-29 16:08:51
 * License: MIT License
 */

export default {
    all: ['#4C5358'],
    gender: ['#70A4BB', '#F29C68'],
    age: ['#1D8AA7', '#70A4BB', '#A5C1D1', '#F8BF9A', '#F29C68', '#EC773B'],
    siteType: ['#F29C68', '#959DA2', '#70A4BB'],
    maritalStatus: ['#959DA2', '#1D8AA7', '#A5C1D1', '#F8BF9A', '#EC773B'],
    education: ['#959DA2', '#70A4BB', '#F29C68', '#EC773B', '#71797E'],
    protectionStatus: ['#1D8AA7', '#70A4BB', '#A5C1D1', '#F29C68', '#F8BF9A', '#B8BEC2'], //This change only makes sense when new csv file is used.
    studyCountry: ['#71797E', '#B8BEC2', '#1D8AA7', '#A5C1D1', '#EC773B', '#F8BF9A'],
    originCountry: ['#EC773B', '#F8BF9A', '#1D8AA7', '#70A4BB', '#71797E', '#B8BEC2'],
    IDPCamp: ['#70A4BB', '#F29C68'],
}
